import React from "react";
import errorImage from "../icons/error.png"; // Tell webpack this JS file uses this image
import { Collapse } from "antd";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error: error,
      errorInfo: errorInfo,
    });

    // Log error info somewhere
  }

  render() {
    if (this.state.errorInfo) {
      return (
        <div>
          <img src={errorImage} alt="Something went wrong!" width="600" height="400" />
          <p>Contact Rixter AB support if the error remains afer refreshing the page.</p>
          <p>
            <a href="https://rixter.atlassian.net/servicedesk/customer/portal/2" target="_blank">
              Go to Rixter AB support portal!
            </a>
          </p>
          <Collapse defaultActiveKey={[1]} ghost>
            <Collapse.Panel header="Error Message" key="1">
              {JSON.stringify(this.state.errorInfo)}
            </Collapse.Panel>
          </Collapse>
        </div>
      );
    }
    return this.props.children;
  }
}
